import React, { useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var BookingContext = /*#__PURE__*/React.createContext([{}, function () {}]);

var BookingProvider = function BookingProvider(props) {
  var _useState = useState({}),
      state = _useState[0],
      setState = _useState[1];

  return /*#__PURE__*/_jsx(BookingContext.Provider, {
    value: [state, setState],
    children: props.children
  });
};

export { BookingContext, BookingProvider };